module.exports = __webpack_public_path__ + "static/media/homepage_artofliving_bg.e87e3469.jpg";